import axios from 'axios';
import {
    LOCAL_STORAGE_ACCESS_TOKEN_KEY,
    REFRESH_PATH,
} from './authConstants';

const walletAxiosClient = axios.create({
    baseURL: process.env.REACT_APP_WALLET_URL || '',
});

let _onWalletError = null;
export const setWalletErrorHandler = (fn) => { _onWalletError = fn; };

const extractMessage = (err) => {
    if (!err.response) return 'Network error — check your connection';
    const {status, data} = err.response;
    if (data?.message) return data.message;
    if (data?.error) return data.error;
    return `Server error (${status})`;
};

walletAxiosClient.interceptors.response.use(
    response => response,
    error => {
        _onWalletError?.(extractMessage(error));
        return Promise.reject(error);
    },
);

export const walletGet = async (url, useAuth = true) =>
    walletRequest(url, {method: 'GET', headers: {}}, useAuth);

export const walletPost = async (url, payload, useAuth = true) =>
    walletRequest(url, {
        method: 'POST',
        data: JSON.stringify(payload),
        headers: {'Content-Type': 'application/json'},
    }, useAuth);

const walletRequest = async (url, options, useAuth = true) => {
    if (useAuth) {
        options.headers.Authorization = buildAuthorizationHeader();
    }
    return walletAxiosClient(url, options).then(r => r.data);
};

function buildAuthorizationHeader() {
    return `Bearer ${localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY)}`;
}

export function logout() {
    localStorage.clear();
    window.location.href = '/login';
}

export {REFRESH_PATH};
